// src/pages/Appli/PresenceAdmin/Users/components/InlineRoleSelect.jsx
import React from "react";

export function InlineRoleSelect({ value, options, onChange, size = "md" }) {
  const cls = size === "sm"
    ? "text-xs px-2 py-1"
    : "text-sm px-2.5 py-1.5";

  return (
    <select
      value={value}
      onChange={(e) => onChange?.(parseInt(e.target.value, 10))}
      className={`rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 ${cls}`}
    >
      {options.map((o) => (
        <option key={o.id} value={o.id}>{o.label}</option>
      ))}
    </select>
  );
}
